module.exports = __webpack_public_path__ + "img/text-classify4.48c3c0ea.png";